module.exports = __webpack_public_path__ + "static/media/media5.fcbcecc9.jpeg";